import styled from "styled-components"

export const ModalContainer = styled.div`
  .modal-box{
  background-color: red!important;
  color: #000!important;
  }
`
